// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import HeadlineReservation from 'components/molecules/HeadlineReservation'
import Button from 'components/atoms/Button'
import ReservationChangeRequestBlock, {
  type PropTypes as ReservationChangeRequestBlockProps,
} from 'components/molecules/ReservationChangeRequestBlock'
import ReservationGetPointBlock, {
  type PropTypes as ReservationGetPointBlockProps,
} from 'components/molecules/ReservationGetPointBlock'
import ReservationAdditionalFeeBlock, {
  type PropTypes as ReservationAdditionalFeeBlockProps,
} from 'components/molecules/ReservationAdditionalFeeBlock'

const ButtonItem = styled.div`
  width: calc((100% - 8px) / 2);
  display: inline-block;

  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }

  ${mediaMin.phone`
    width: 160px;
    font-size: ${fontSize.small_3}px;
  `};
`
const TotalFeeWrap = styled.div`
  ${mediaMin.phone`
    margin-top: ${spacing.medium}px;
    padding-top: ${spacing.medium}px;
    border-top: 1px dashed ${Colors.grayE};
  `};
`

type PropTypes = {
  reservationChangeRequestBlockProps: ReservationChangeRequestBlockProps,
  reservationGetPointBlockProps: ReservationGetPointBlockProps,
  reservationAdditionalFeeBlockProps: ReservationAdditionalFeeBlockProps,
  onClickBackToMessage: Function,
}

export default function ReservationChangeGuestPage(props: PropTypes) {
  return (
    <React.Fragment>
      <HeadlineReservation
        title={i18n.t(
          'page.dashboard.reservation.reservationChangeFromGuest.title',
        )}
        href="#"
        linkText={i18n.t('page.dashboard.reservation.backToMessage')}
        onClick={props.onClickBackToMessage}
      >
        {i18n.t('page.dashboard.reservation.reservationChangeFromGuest.desc')}
      </HeadlineReservation>
      <ReservationChangeRequestBlock
        {...props.reservationChangeRequestBlockProps}
      />
      <ReservationGetPointBlock {...props.reservationGetPointBlockProps} />
      <ReservationAdditionalFeeBlock
        {...props.reservationAdditionalFeeBlockProps}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationChangeGuestForm/index.jsx